/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../navigation/ui/AutoHidingControl'
], function(View) {

	var NavControl = View.extend({

		init: function(options) {
			NavControl.inherited('init', this, arguments);
			this.subview = options.subview;
		},

		remove: function() {
			NavControl.inherited('remove', this, arguments);
		},

		_renderContent: function() {
			if(this.subview) {
				this.subview.$el.appendTo(this.$el.empty()).show();
			}

			return Promise.resolve();
		},

		_show: function(options) {
			var duration = options && options.duration || 'fast';
			return new Promise((resolve) => {
				this.$el.css({
					'pointer-events': ''
				});
				// You'd think it'd be slideUp here, but this is what works.
				this.$el.slideDown(duration, function() {
					// Force refresh of the progress bar to ensure the scaleInfo is accurate.
					if(this.subview) {
						this.subview.updateProgressBar();
					}
					resolve();
				}.bind(this));
			});
		},

		_hide: function(options) {
			var duration = options && options.duration || 'fast';
			return new Promise((resolve) => {
				if(this.subview && this.subview._flyout) {
					this.subview._flyout.close();
				}
				this.$el.css({
					'pointer-events': 'none'
				});
				// You'd think it'd be slideDown here, but this is what works.
				this.$el.slideUp(duration, function() {
					resolve();
				});
			});
		}

	});

	return NavControl;
});
